import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "./cn"

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium [&_svg]:size-3 avex:h-6 avex:px-2.5 avex:py-0 avex:font-semibold",
  {
    variants: {
      tone: {
        neutral: "bg-gray-100 text-gray-700 avex:bg-surface-sunken avex:text-ink-secondary",
        success: "bg-emerald-50 text-emerald-700 avex:bg-success-soft avex:text-success",
        warning: "bg-amber-50 text-amber-800 avex:bg-warning-soft avex:text-warning",
        danger: "bg-red-50 text-red-700 avex:bg-danger-soft avex:text-danger",
        info: "bg-blue-50 text-blue-700 avex:bg-info-soft avex:text-info"
      }
    },
    defaultVariants: { tone: "neutral" }
  }
)

/**
 * A status as a word in a pill. The tone carries the meaning together with
 * the word, never colour alone — the same rule as the design system's Badge.
 */
function Badge({ className, tone, ...props }: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return <span data-slot="badge" className={cn(badgeVariants({ tone }), className)} {...props} />
}

export { Badge, badgeVariants }
